import { createContext, useContext, type ReactNode } from 'react';
import {
  DEFAULT_ASSISTANT_SETTINGS,
  normalizeAssistantSettings,
  type AssistantSettings,
  type AssistantTranslations,
} from './assistant';

export interface AssistantContextValue {
  assistant: AssistantSettings;
  /** Null selects the bundled standard avatar. */
  avatarUrl: string | null;
  translations: AssistantTranslations | null;
}

const AssistantContext = createContext<AssistantContextValue>({
  assistant: DEFAULT_ASSISTANT_SETTINGS,
  avatarUrl: null,
  translations: null,
});

export interface AssistantProviderProps {
  children: ReactNode;
  assistant?: AssistantSettings | null;
  avatarUrl?: string | null;
  translations?: AssistantTranslations | null;
}

export function AssistantProvider({
  children,
  assistant,
  avatarUrl = null,
  translations = null,
}: AssistantProviderProps) {
  const value: AssistantContextValue = {
    assistant: normalizeAssistantSettings(assistant),
    avatarUrl,
    translations,
  };

  return <AssistantContext.Provider value={value}>{children}</AssistantContext.Provider>;
}

export function useAssistant(): AssistantContextValue {
  return useContext(AssistantContext);
}
